import React from 'react';
import { Layout } from 'antd';
import { BasicProps } from 'antd/lib/layout/layout';
import classes from './Blank.module.scss';
import cn from 'classnames';

type BlankLayoutProps = Omit<BasicProps, 'prefixCls' | 'hasSider'> & {
  shadow?: boolean;
  children: React.ReactNode;
};

export const BlankLayout: React.FC<BlankLayoutProps> = (props) => {
  const { shadow, children, className, ...layoutProps } = props;

  return (
    <Layout.Content
      {...layoutProps}
      className={cn(
        classes.blank,
        { [classes['blank--shadow']]: shadow },
        className
      )}
    >
      {children}
    </Layout.Content>
  );
};
